import { Flex, Text, Toggle, Box } from '@vibe/core';

type ToggleSettingProps = {
  title: string;
  description?: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export function ToggleSetting({ title, value, onChange }: ToggleSettingProps) {
  return (
    <Flex direction="row" style={{ width: '100%' }}>
      <Text type="text2">{title}</Text>
      <Box style={{ marginLeft: 'auto' }}>
        <Toggle
          className="Toggle"
          areLabelsHidden
          isSelected={value}
          size="small"
          onChange={() => {
            onChange(!value);
          }}
        />
      </Box>
    </Flex>
  );
}
